import { render } from "./ForYouPage.vue?vue&type=template&id=0b161f86"
import script from "./ForYouPage.vue?vue&type=script&lang=js"
export * from "./ForYouPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__